// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nz-c";
export var backButton = "_nz-4";
export var backIcon = "_nz-5";
export var chevronShortcut = "_nz-6";
export var container = "_nz-1";
export var editor = "_nz-8";
export var editorWrapper = "_nz-7";
export var prefix = "_nz-2";
export var searchIcon = "_nz-3";
export var suffix = "_nz-9";
export var suffixContent = "_nz-a";
export var suffixText = "_nz-b";
export var wrapper = "_nz-0";